module.exports = __webpack_public_path__ + "img/1007.2c50122d.jpg";